// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSteps-ListItem_cls1__cSPsT","cls2":"VeloSteps-ListItem_cls2__9j9Hd VeloSteps-ListItem_cls1__cSPsT"};